import React from 'react';

import Section from 'Elements/Section';
import Main from 'Elements/Main';
import Grid, { Col } from 'Components/Grid';

import Breadcrumbs, { BreadcrumbsProps } from 'Components/Breadcrumbs';
import TranscriptEmbed, { TranscriptEmbedProps } from 'Components/Video/TranscriptEmbed';

export interface Props {
    breadcrumbs: BreadcrumbsProps;
    video: TranscriptEmbedProps;
    heading: string;
}

const Story: React.FC<Props> = ({ breadcrumbs, video, heading }) => {
    return (
        <Main>
            <Breadcrumbs {...breadcrumbs} />
            <Grid>
                <Col>
                    <Section id="transcriptEmbed" paddingTop={2.5}>
                        <h1>{heading}</h1>
                        <TranscriptEmbed {...video} />
                    </Section>
                </Col>
            </Grid>
        </Main>
    );
};

export default Story;
